var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Developer Interview Articles","is_createable":true,"operations":_vm.operations,"fields":_vm.fields,"response":_vm.data},on:{"edit_click":_vm.editClick,"create":_vm.createArticle,"delete":_vm.deleteArticle,"comments":_vm.openArticleComments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }